import * as React from 'react'

export const IconSuccessMsg: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: Omit<
    React.SVGProps<SVGSVGElement>,
    'dominantBaseline' | 'textAnchor' | 'clipRule' | 'fillRule' | 'strokeLinecap' | 'strokeLinejoin'
  >
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width="16" height="16" x="4" y="4" fill="url(#paint0_linear_23264_16321)" rx="4" />
    <path
      fill="#fff"
      d="M15.583 9.803a.626.626 0 0 0-.903-.002l-3.603 3.73-1.76-1.817a.624.624 0 0 0-.898.868l1.939 2.007a1 1 0 0 0 1.438 0l3.785-3.918a.626.626 0 0 0 .002-.868"
    />
    <defs>
      <linearGradient
        id="paint0_linear_23264_16321"
        x1="12"
        x2="12"
        y1="4"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#82E69F" />
        <stop offset="1" stopColor="#4F9F52" />
      </linearGradient>
    </defs>
  </svg>
)
